import React, { useState } from "react";
import RoiCalculatorWidget from "./RoiCalculatorWidget";
import Industries_carousel_pa from "./Industries_carousel_pa";
import Industries_carousel_global from "./industries_carousel_global";
import Modal_started from "../Home/Modal_started";
import { useTranslation } from "react-i18next";

import { Link, useLocation } from "react-router-dom";
import useLocalePrefix from "../utils/useLocalePrefix";

const Kds_new = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(0);

  const features = [
    {
      tag: "Inventario al día",
      title: "Gestión de inventario automática",
      description:
        "Que reduzca pérdidas, avise cuando falten ingredientes y permita compras inteligentes.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-INVENTARIO-AUTOMATICA_kow1hl.png",
    },
    {
      tag: "Facturación electrónica",
      title: "Facturación digital eficiente",
      description:
        "Genera facturas electrónicas al instante, lleva un control de tus ventas y cumple con todos los requisitos fiscales sin complicaciones.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/FACTURACION-DIGITAL-EFICIENTE_bzc8pt.png",
    },
    {
      tag: "Control de mesas",
      title: "Gestión del personal",
      description:
        "Control de turnos, comisiones, rendimiento y roles dentro del sistema.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/GESTION-DE-PERSONAL_jzcmhm.png",
    },
    {
      tag: "InvuReport",
      title: "Reportes avanzados de ventas",
      description:
        "Gráficos y análisis por plato, turno, mes o empleado para tomar decisiones rápidas.",
      image:
        "https://img.invupos.com/webinvu/Kds_new/REPORTES-AVANZADOS-DE-VENTAS_wzaucp.png",
    },
    {
      tag: "Control de mesas",
      title: "Control de mesas y reservas",
      description:
        "Visualización clara de ocupación, tiempos de permanencia y disponibilidad en tiempo real.",
      image:
        "https://img.invupos.com/webinvu/homenew/Whatsapp%20Catalogo-12%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Manejo de promociones",
      description:
        "Crear ofertas, combos y descuentos fácilmente sin afectar inventario ni contabilidad.",
      image:
        "https://img.invupos.com/webinvu/homenew/invu%20mockups%20multiple%20screens%203.png",
    },
    {
      tag: "Control de mesas",
      title: "Para franquicias o sucursales",
      description:
        "Administración centralizada si tienen más de un local, con reportes consolidados.",
      image:
        "https://img.invupos.com/webinvu/homenew/1%202.png",
    },
  ];

  const integrations = "https://img.invupos.com/webinvu/Kds_new/INVU_POS_El_Salvador-9_3_t18s5r.png"

  const features1 = [
    { text: "Incrementa tickets" },
    { text: "Cocina siempre sincronizada" },
    { text: "Preparación más rápida" },
    { text: "Flujo de trabajo eficiente" },
    { text: "Reduce errores" },
    { text: "Alerta de comanda" },
    { text: "Pedidos Online" },
    { text: "Reportes de cocina" },
    { text: "Mide los tiempos en cocina" },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % features.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + features.length) % features.length);
  };

  // ✅ Siempre devuelve 3 cards, ciclando los índices con módulo
  const getVisibleCards = () => {
    const cards = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentSlide + i) % features.length;
      cards.push({ ...features[index], originalIndex: index });
    }
    return cards;
  };

  const faqs = [
    {
      question: "¿Qué es el KDS de Invu POS y cómo ayuda a mi restaurante?",
      answer:
        "El KDS de Invu POS es un sistema de pantallas de cocina que organiza todas tus órdenes en tiempo real. Elimina tickets impresos, reduce errores y acelera la salida de los platos. Todo entra ordenado, claro y con prioridades visibles para tu equipo",
    },
    {
      question: "¿El KDS funciona para cualquier tipo de restaurante?",
      answer:
        "Sí. Nuestro KDS se adapta a cocinas rápidas, cafeterías, dark kitchens, food trucks y restaurantes a gran escala. Puedes crear estaciones por categoría (cocina fría, caliente, bar, postres) y cada orden se envía automáticamente al área correcta. ",
    },
    {
      question: "¿Cómo se conecta el KDS con mi sistema actual?",
      answer:
        "El KDS está 100% integrado con Invu POS. Cada pedido que entra —sea en mesa, delivery o pickup— aparece de inmediato en la pantalla de cocina. No necesitas configuraciones complejas: solo conectas la pantalla y estás listo para trabajar.",
    },
    {
      question: "¿Puedo ver los tiempos de preparación y medir el rendimiento de mi cocina?",
      answer:
        "Sí. El KDS registra los tiempos de cada orden y te muestra estadísticas clave: platos más lentos, horas pico, tiempos promedio y desempeño por estación. Esto te permite optimizar tu operación y mejorar la experiencia del cliente. ",
    },
    {
        question: "¿Qué equipos necesito para usar el KDS? ",
        answer:
          "Puedes usar pantallas táctiles, tablets o monitores estándar. El sistema corre en la nube, por lo que no necesitas servidores ni instalaciones complicadas. Solo wifi y un dispositivo que ya tengas en tu cocina. ",
      },
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [isOpen, setIsOpen] = useState(false);
  const extendedFeatures = [...features, ...features, ...features];

      // const extendedFeatures = [...features, ...features, ...features]; 
      const featuresList = t("features1kdsnew", { returnObjects: true });
      const extendedFeaturesList = t("featuresecommercenew", { returnObjects: true });
      const faqList = t("faqskdsnew", { returnObjects: true });
    
      const isMobile =
      typeof window !== "undefined" && window.innerWidth < 768;

      const location = useLocation();
      const prefix = useLocalePrefix();
    
    const cardsPerSlide = isMobile ? 1 : 3;
  return (
    <>
    {isOpen && <Modal_started setIsOpen={setIsOpen} />}
       <div className="px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl">
          {/* Grid con proporciones personalizadas */}
          <div className="grid lg:grid-cols-[45%_55%] gap-12 items-center px-8">
            {/* Contenido de texto */}
            <div className="space-y-8">
              <h1 className="text-6xl md:text-6xl lg:text-6xl font-bold mt-8">
              {t("kdstitle1")}{" "}
                <span className="text-blue-600">{t("kdsspan1")}</span>
              </h1>

              <p className="text-xl md:text-2xl text-gray-700 leading-relaxed">
             {t("kdsdescription1")}
              </p>

              <button 
               onClick={() => {
                setIsOpen(true);
              }}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-16 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                {t("kdsbutton")}
              </button>
            </div>

            {/* Imagen */}
            <div className="relative lg:my-10 lg:mx-4 my-4">
              <div className="flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Kds_new/INVU_POS_El_Salvador-13_3_pigtgp.png"
                  alt="Mockup Invu POS"
                  className="rounded-2xl w-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className=" bg-gray-50 px-6 py-16 md:py-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* Espacio para imagen del teléfono */}
            <div className="order-2 lg:order-1 flex justify-center">
              <div className="relative">
                <img
                  className="h-auto"
                  src="https://img.invupos.com/webinvu/Point%20of%20sale%20module/KDS-Mockup.png"
                />
              </div>
            </div>

            {/* Contenido de texto */}
            <div className="order-1 lg:order-2 space-y-8">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                {t("kdstitle2")}
              </h2>

              <p className="text-lg md:text-xl text-gray-700 leading-relaxed">
              {t("kdsdescription2")}
              </p>

              {/* Grid de características */}
              <div className="grid sm:grid-cols-2 gap-4 pt-4">
                {featuresList.map((feature, index) => (
                  <div key={index} className="flex items-start gap-3 group">
                    <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mt-1 group-hover:scale-110 transition-transform duration-200">
                      <svg
                        className="w-4 h-4 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={3}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                    <span className="text-base md:text-lg font-semibold text-gray-900 leading-snug">
                      {feature.text}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

<Industries_carousel_global/>


 {/* SISTEMA INTEGRADO */}
 <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
        <h2 className="text-4xl sm:text-5xl font-extrabold">
          {t("kdsctatitle")} <span className="text-blue-600">{t("kdsctatitlespan")}</span>
        </h2>
        <div className="mt-8 grid lg:grid-cols-2 gap-10 items-center">
          <div className="max-w-2xl text-gray-700 text-lg">
            {t("kdsctadescription")}
            <div className="mt-6">
            <Link 
            to={"/mas-herramientas/integraciones"} className="px-6 py-3 rounded-full bg-blue-600 text-white font-semibold inline-block">{t("kdsctabutton")}</Link>
            </div>
          </div>
          <div className="max-w-2xl mx-auto">
            {integrations ? (
              <img src={integrations} alt="Integraciones" className="w-full rounded-2xl" />
            ) : (
              <div className="w-full h-72 bg-gray-100 rounded-2xl" />
            )}
          </div>
        </div>

        {/* Métricas */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">{t("kdscard1title1")}</div>
            <div className="mt-3 text-5xl font-extrabold">100<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">{t("kdscard1description1")}</p>
          </div>
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">{t("kdscard2title1")}</div>
            <div className="mt-3 text-5xl font-extrabold">99<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">{t("kdscard2description1")}</p>
          </div>
          <div className="rounded-2xl bg-white border p-6">
            <div className="text-xs font-semibold text-rose-500 uppercase tracking-wide">{t("kdscard3title1")}</div>
            <div className="mt-3 text-5xl font-extrabold">45<span className="text-3xl align-top">%</span></div>
            <p className="mt-3 text-sm text-gray-600">{t("kdscard3description1")}</p>
          </div>
        </div>
      </section>


      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-8">
  <div className="max-w-7xl mx-auto">
    {/* Header */}
    <div className="flex flex-col lg:flex-row justify-between items-center gap-6 mb-12 text-center lg:text-left">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 max-w-2xl leading-tight">
        {t("reasons_title")}
      </h1>

      <button
        onClick={() => {
          setIsOpen(true);
        }}
        className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-base sm:text-lg px-10 sm:px-16 py-3 sm:py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
      >
        {t("reasons_cta")}
      </button>
    </div>

    {/* Carousel */}
    <div className="relative overflow-hidden">
      <div
        className="flex transition-transform duration-700 ease-[cubic-bezier(0.22,1,0.36,1)]"
        style={{
          transform: `translateX(-${currentSlide * (100 / cardsPerSlide)}%)`,
        }}
      >
        {extendedFeaturesList.map((feature, idx) => (
          <div
            key={idx}
            className="w-full md:w-1/3 flex-shrink-0 px-3 md:px-4 animate-fadeup"
            style={{ animationDelay: `${(idx % 3) * 0.1}s` }}
          >
            {/* Card */}
            <div className="group relative bg-white rounded-3xl p-8 shadow-sm hover:shadow-2xl hover:-translate-y-2 hover:scale-[1.02] transition-all duration-700 ease-in-out overflow-hidden h-full flex flex-col">
              {/* Brillo diagonal */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"></div>

              {/* Borde brillante */}
              <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-blue-100 transition-all duration-700"></div>

              {/* Tag */}
              <div className="flex items-center justify-between mb-6">
                <span className="text-blue-600 font-semibold text-sm">
                  {feature.tag}
                </span>
                <div className="bg-blue-600 rounded-full p-1.5 flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M13 4L6 11L3 8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 mb-6 leading-relaxed flex-grow">
                {feature.description}
              </p>

              {/* Image */}
              <div className="relative bg-white rounded-2xl overflow-hidden flex items-center justify-center h-64 mb-6">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="object-contain max-h-full max-w-full transition-transform duration-700 ease-in-out group-hover:scale-110"
                />
              </div>

              {/* Plus Button */}
              <div>
                <button className="mt-auto bg-blue-50 hover:bg-blue-100 rounded-full p-3 transition-transform duration-500 hover:scale-110 shadow-sm">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M10 4V16M4 10H16"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botones */}
      <div className="flex justify-center gap-4 mt-6">
        <button
          onClick={prevSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Anterior"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <button
          onClick={nextSlide}
          className="bg-white hover:bg-gray-100 rounded-full p-4 shadow-md transition-transform hover:scale-110"
          aria-label="Siguiente"
        >
          <svg className="w-6 h-6 text-gray-700" viewBox="0 0 24 24" fill="none">
            <path
              d="M9 18L15 12L9 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>

      {/* Indicadores */}
      <div className="flex justify-center gap-2 mt-6">
        {features.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`h-2 rounded-full transition-all ${
              idx === currentSlide
                ? "w-8 bg-blue-600"
                : "w-2 bg-gray-300 hover:bg-gray-400"
            }`}
            aria-label={`Ir a slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  </div>
</div>


<div className="min-h-screen bg-gray-100 py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Left Card - Aliados */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden">
              {/* Header */}

              <h2 className="text-4xl lg:text-5xl font-bold text-black mb-8">
                <span className="text-blue-600">{t("kioskcta1span")}</span> {t("kioskcta1title")}
              </h2>

              {/* Description */}
              <p className="text-gray-700 text-lg leading-relaxed mb-12">
             {t("kioskcta1description")}
              </p>

              {/* Imagen CLAU.IO */}
              <div className="relative bg-gray-50 rounded-2xl overflow-hidden h-80 mb-8 flex items-center justify-center">
                <img
                  src="https://img.invupos.com/webinvu/Kiosk_new/img3.png"
                  alt="Plataforma CLAU.IO"
                  className="w-full h-full object-contain"
                />
              </div>

               {/* CTA Button */}
               <Link
              to={`${prefix}` + "/productos/quioscos"}
              onClick={() => window.scrollTo(0, 0)}
              className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-10 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
               {t("kioskcta1button")}
              </Link>
            </div>

            {/* Right Card - Loyalty */}
            <div className="bg-white rounded-3xl p-12 shadow-lg relative overflow-hidden flex flex-col">
              {/* Header */}
              <div className="text-center mb-8">
                <h2 className="text-4xl lg:text-5xl font-bold mb-6">
                  <span className="text-black">{t("kioskcta2title")} </span>
                  <span className="text-blue-600">{t("kioskcta2span")}</span>
                </h2>

                {/* Description */}
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {t("kioskcta2description")}
                </p>

                {/* CTA Button */}
                <Link
                to={`${prefix}` + "/productos/programa-de-lealtad"}
                onClick={() => window.scrollTo(0, 0)}
                className="bg-gradient-to-r from-[#0056FB] to-[#003395] text-white font-semibold text-lg px-24 py-4 rounded-full transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105">
                  {t("kioskcta2button")}
                </Link>
              </div>

              {/* Imagen de celulares */}
              <div className="relative flex-1 flex items-end justify-center mt-8">
                <div className="w-full h-96 bg-gray-50 rounded-2xl overflow-hidden flex items-center justify-center">
                  <img
                    src="https://img.invupos.com/webinvu/Kiosk_new/img4.png"
                    alt="Apps móviles Loyalty"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div className="min-h-screen bg-white py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
            {/* Left Side - Imagen FAQ Ecommerce */}
            <div className="flex justify-center lg:justify-center">
              <img
                src="https://img.invupos.com/webinvu/Kds_new/Frame_1707482105_w1zmig.png"
                alt="Preguntas frecuentes Ecommerce"
                className=" block w-full max-w-[420px] h-auto object-contain"
              />
            </div>

            {/* Right Side - FAQ Section */}
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12">
                {t("faqkdstitle")}
              </h2>

              {/* FAQ Items */}
              <div className="space-y-4">
                {faqList.map((faq, index) => (
                  <div key={index} className="border-b border-gray-200">
                    <button
                      onClick={() => toggleFaq(index)}
                      className="w-full py-6 flex items-center justify-between text-left hover:text-gray-600 transition-colors"
                    >
                      <span className="text-lg font-medium text-gray-900 pr-4">
                        {faq.question}
                      </span>
                      <span className="text-2xl text-gray-500 flex-shrink-0">
                        {openIndex === index ? "−" : "+"}
                      </span>
                    </button>
                    {openIndex === index && (
                      <div className="pb-6 text-gray-600 leading-relaxed">
                        {faq.answer}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Banner */}
          <div className=" relative bg-gradient-to-r from-[#0056FB] to-[#003395] rounded-3xl p-12 overflow-hidden max-w-6xl mx-auto mt-14">
            {/* Decorative Circle */}
            <div className="absolute right-2 top-1/2 -translate-y-1/2 w-64 h-64 opacity-20">
              <img src="https://img.invupos.com/webinvu/Kds_new/logo-INVU-POS-blanco_1_7_dvfhgc.png" />
            </div>

            <div className="relative z-10 max-w-3xl mx-auto text-center">
              <h3 className="text-3xl lg:text-5xl font-bold text-white mb-8 leading-tight">
              {t("kdscta3title1")}
              </h3>
              <button 
               onClick={() => {
                setIsOpen(true);
              }}
              className="bg-white hover:bg-gray-100 text-blue-600 font-bold px-8 py-4 rounded-full transition-colors text-lg uppercase tracking-wide">
                {t("kdscta3button")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Kds_new;